export default __webpack_public_path__ + "static/media/input_checked.b537feb7.svg";